module.exports = __webpack_public_path__ + "img/music.beb43dc4.svg";